"use client";

import React from "react";

import Link from "next/link";
import { useDomain } from "../context/DomainContext";


import {

  Mail,

  Phone,

  Facebook,

  Twitter,

  Instagram,

  Linkedin,

  Youtube,

  Globe,

  Clock,

  Shield,

  Award,

  ArrowRight,

  ExternalLink,
  MapPin

} from "lucide-react";

import Image from "next/image";

import { useLanguage } from "../context/LanguageContext";


const officeAddresses = [

  {
    country: "Thailand",
    city: "Bangkok",
    company: "DUDIGITAL GLOBAL (THAILAND) COMPANY LTD.",
    address:
      "Unit No. 36/28, 10th Floor, P.S. Tower, Sukhumvit 21 (Asoke) Road, North Klongtoey Sub-district, Wattana District, Bangkok",
  },
  {
    country: "Sri Lanka",
    city: "Nugegoda",
    company: "DUDIGITAL GLOBAL (LANKA) (PVT) LTD.",
    address:
      "No. 8, 1/2, Old Kesbewa Road, Delkanda Nugegoda, Post Code – 10250",
  },
  {
    country: "South Korea",
    city: "Seoul",
    company: "DUDIGITAL GLOBAL (KOREA) LLC",
    address:
      "4th Floor, 76-42, Namhan Building, Hannam-Dong, Yongsan-Gu, Seoul, South Korea – 04401",
  },
  {
    country: "UAE",
    city: "Sharjah",
    company: "DUDIGITAL GLOBAL LLC",
    address:
      "Sharjah Media City (Shams) P.O. Box: 515000 Sharjah, UAE",
  },

];



const Footer = () => {

  const { t } = useLanguage();
  const { domain, loading } = useDomain();

  if (loading) return null;



  return (

    <footer className="relative bg-gray-900 text-gray-300 border-t border-gray-800 z-50">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">



        {/* TOP ROW */}

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">



          {/* ABOUT */}

          <div className="md:col-span-1">

            <div className="flex items-center gap-2 mb-3">

              {/* <Globe className="h-6 w-6 text-blue-400" /> */}

              <Image

              src="/DU-Global-Footer-Logo-1.png"

              alt="DU Digital"

              width={170}

              height={50}

            />


            </div>
 <h3 className="text-xl font-semibold text-white">
                {t("DUDIGITAL GLOBAL LLC")}
              </h3>

            {/* Social Icons */}

            <div className="flex gap-3 mt-4">
              {[
                {
                  icon: Facebook,
                  color: "hover:bg-blue-600",
                  link: "https://www.facebook.com/DuGlobalOfficial/",
                },
                {
                  icon: Twitter,
                  color: "hover:bg-blue-400",
                  link: "https://x.com/dudigitalglobal",
                },
                {
                  icon: Instagram,
                  color: "hover:bg-pink-600",
                  link: "https://www.instagram.com/du_global/",
                },
                {
                  icon: Linkedin,
                  color: "hover:bg-blue-700",
                  link: "https://www.linkedin.com/company/du-global/",
                },
                {
                  icon: Youtube,
                  color: "hover:bg-red-600",
                  link: "https://youtube.com/@Du_Global?reload=9",
                },
              ].map((item, i) => (
                <a
                  key={i}
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`p-2 rounded-md bg-gray-800 transition-all duration-200 ${item.color}`}
                  aria-label="Social Media Link"
                >
                  <item.icon className="h-4 w-4 text-gray-400 hover:text-white" />
                </a>
              ))}
            </div>


          </div>



          {/* QUICK LINKS */}

          <div>

            <h4 className="text-white font-semibold mb-4">

              {t("Quick Links")}

            </h4>

            <ul className="space-y-3 text-sm">

              {[

                { href: "/", label: t("Home") },

                { href: "/services", label: t("Our eVisas") },

                { href: "/about", label: t("About Us") },

                // { href: "/dashboard", label: t("nav.apply") },

                // { href: "/track", label: t("nav.track") },

              ].map((link, i) => (

                <li key={i}>

                  <Link

                    href={link.href}

                    className="hover:text-white transition flex items-center gap-2"

                  >

                    <ArrowRight className="h-3 w-3" />

                    {link.label}

                  </Link>

                </li>

              ))}

            </ul>

          </div>



          {/* SUPPORT */}

          <div>

            <h4 className="text-white font-semibold mb-4">

              {t("Quick Links")}

            </h4>

            <ul className="space-y-3 text-sm">

              {[

                // { href: "/faq", label: t("nav.faq") },

                { href: "/contact", label: t("Contact Us") },

                { href: "/contact", label: t("Help Centre") },

              ].map((link, i) => (

                <li key={i}>

                  <Link

                    href={link.href}

                    className="hover:text-white transition flex items-center gap-2"

                  >

                    <ArrowRight className="h-3 w-3" />

                    {link.label}

                  </Link>

                </li>

              ))}

            </ul>

          </div>

           <div>

            <h4 className="text-white font-semibold mb-4">

              {t("Quick Links")}

            </h4>

            <ul className="space-y-3 text-sm">

              {[

                { href: "/faqs", label: t("FAQs") },

                { href: "/required-documents", label: t("Required Documents") },


              ].map((link, i) => (

                <li key={i}>

                  <Link

                    href={link.href}

                    className="hover:text-white transition flex items-center gap-2"

                  >

                    <ArrowRight className="h-3 w-3" />

                    {link.label}

                  </Link>

                </li>

              ))}

            </ul>

          </div>


        </div>

        {/* CONTACT */}
      <div className="md:col-span-4 mt-5">
        <h4 className="text-white font-semibold mb-6">
          {t("Contact Us")}
        </h4>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">

          {/* EMAIL */}
          <div className="flex gap-3 bg-gray-800/40 rounded-lg p-4 border border-gray-700">
            <Mail className="h-5 w-5 text-blue-400 mt-1 flex-shrink-0" />

            <div>
              <p className="text-xs text-gray-500 mb-1">
                {t("Email Support")}
              </p>

              <a
                href={`mailto:${domain?.cc_email}`}
                className="hover:text-white break-all"
              >
                {domain?.cc_email}
              </a>
            </div>
          </div>

          {/* PHONE */}
          <div className="flex gap-3 bg-gray-800/40 rounded-lg p-4 border border-gray-700">
            <Phone className="h-5 w-5 text-green-400 mt-1 flex-shrink-0" />

            <div>
              <p className="text-xs text-gray-500 mb-1">
                {t("Phone Support")}
              </p>

              <div
                className="text-white leading-relaxed"
                dangerouslySetInnerHTML={{
                  __html: domain?.cc_phone,
                }}
              />
            </div>
          </div>

          {/* WORKING HOURS */}
          <div className="flex gap-3 bg-gray-800/40 rounded-lg p-4 border border-gray-700">
            <Clock className="h-5 w-5 text-purple-400 mt-1 flex-shrink-0" />

            <div>
              <p className="text-xs text-gray-500 mb-1">
                {t("Working Hours")}
              </p>

              <div className="text-white">
                {domain?.working_time}
              </div>
            </div>
          </div>

        </div>
      </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mt-5" id="footer">
            {/* OFFICE LOCATIONS */}
            <div className="lg:col-span-4">
              <h4 className="text-white font-semibold mb-6 text-left">
                {t("Our Offices")}
              </h4>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {officeAddresses.map((office, index) => (
                  <div
                    key={index}
                    className="bg-gray-800/60 border border-gray-700 rounded-lg p-4 hover:border-white transition"
                  >
                    <div className="flex items-start gap-3">
                      <MapPin className="h-4 w-4 text-red-400 mt-1 flex-shrink-0" />
                      <div>
                        <p className="text-white font-medium">
                          {office.city}, {office.country}
                        </p>
                        <p className="text-gray-400 text-sm leading-relaxed">
                          {office.company}
                        </p>
                        <p className="text-gray-400 text-sm leading-relaxed">
                          {office.address}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>


            </div>


      </div>



      {/* Bottom Section */}

        <div className="border-t border-gray-700/50">

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">

            <div className="flex flex-col md:flex-row justify-between items-center gap-4">

              {/* Copyright */}

              <div className="text-gray-400 text-sm text-center md:text-left">

                {t("Copyright")}

              </div>



              {/* Legal Links */}

              <div className="flex flex-wrap justify-center gap-6 text-sm">


                <a href="/terms-conditions" className="text-gray-400 hover:text-white transition-colors flex items-center gap-1 cursor-pointer">

                  {t("Terms & Condition and Privacy Policy")}

                  <ExternalLink className="h-3 w-3" />

                </a>

                <a href="/refund" className="text-gray-400 hover:text-white transition-colors flex items-center gap-1 cursor-pointer">

                  {t("Refund Policy")}

                  <ExternalLink className="h-3 w-3" />

                </a>

                <a href="/disclaimer" className="text-gray-400 hover:text-white transition-colors flex items-center gap-1 cursor-pointer">

                  {t("Disclaimer")}

                  <ExternalLink className="h-3 w-3" />

                </a>

              </div>

            </div>

          </div>

        </div>

    </footer>

  );

};



export default Footer;

